import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner} from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import Country from "../classes/Country";
import ColorPicker from "../components/ColorPicker";
import {Warning   } from "@phosphor-icons/react";




const { Formik } = formik;

class DialogChangeColor extends React.Component {

	
	constructor(props) {
		super(props);
	
		this.state = {
			validated: false,
			status: {sent:null, message:''},
			colorChange: false
		}
		
		//this.owner = schemas.owner.cast(this.props.setup.owner);
		
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}

	handleOnSave(data){
		if(this.props.setup.onSave)
			this.props.setup.onSave(data);
	};
	handleClose(data){
		
		this.props.onClose(data);
		this.updateStatus({status:{sent:null, message:'', owner:null, colorChange:false}});
	};
	handleOnShow(e){
		
	};

	handleSubmit(data){
		
		this.updateStatus({status:{sent:false, success:false, message:'Saving...'}});

		atlasApi.updateOwnerColor(data).then((resp)=>{
			if(resp.id){   //update user response format || insert user response format

				this.updateStatus({status:{sent:true, success:true, message:'Color saved'}});
				this.handleOnSave(data);
				setTimeout(()=>this.handleClose(data), 1000);
			}
			else
				this.updateStatus({status:{sent:true, success:false, message:'Error saving color'}});
		}).catch((e)=>{
			this.updateStatus({status:{sent:true, success:false, message:'Error saving color'}});
		});
	};


	render() {
		if(!this.props.setup.owner)
			return;
		return (
			<Modal show={this.props.setup.open} size="sm" backdropClassName="change-color-backdrop" className="dialog-color" onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>{this.props.setup.owner.companyName ?	this.props.setup.owner.companyName : this.props.setup.owner.fullName}</Modal.Title>
				</Modal.Header>
				<Formik validationSchema={schemas.color} onSubmit={this.handleSubmit.bind(this)} initialValues={{id:this.props.setup.owner.id, color:this.props.setup.owner.color}}>	
					{({ handleSubmit, handleChange, values, touched, errors, isValid, dirty,setFieldValue }) => (
						<Form noValidate onSubmit={handleSubmit}>
							<input type="hidden" name="id" value={values.id} />
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
									
										{
										this.state.colorChange && 
										<Row className="mb-3">
											<Col xs="1" className="text-danger">
												<Warning size={16} />
											</Col>
											<Col xs="11">
												<b>Note:</b> Changing the landowner color is site-wide and will affect projects with this landowner.
											</Col>
										</Row>
										}
										
										<Row>
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												
												<Form.Label className="d-block">Landowner color</Form.Label>
	
											</Form.Group>
		
											
										</Row>
										
										<Row className="mb-3">
											<Form.Group as={Col} md="6" controlId="validationFormik01">
												
												<ColorPicker name="color" onChange={(color)=>{this.updateStatus({colorChange:true}, setFieldValue("color", color)); }} color={values.color} />
												
											</Form.Group>
											
											<Form.Group as={Col} md="6" className="text-end" controlId="validationFormik099">
												<Button variant="primary" type="submit">Save color</Button>
											</Form.Group>
											
										</Row>
										
										
									</Modal.Body>
									
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogChangeColor;